import { NavLink } from "react-router-dom";
import { clsx } from "clsx";
import { groupedBySection } from "./adminManifest";

/**
 * Admin sidebar — vertical nav list with section headers and icons.
 *
 * Sections + items come from `adminManifest` via `groupedBySection()`
 * so the sidebar automatically covers every admin module — real ports
 * and stubs alike. Items remain in the sidebar even when stubbed so
 * users know they exist (and get a link back to legacy KGAI).
 */
export function Sidebar() {
  const sections = groupedBySection();

  return (
    <aside className="w-60 border-r border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-950 flex flex-col">
      <div className="h-14 px-4 flex items-center border-b border-gray-200 dark:border-gray-800">
        <span className="font-semibold text-gray-900 dark:text-white">
          KG Admin
        </span>
      </div>
      <nav className="flex-1 overflow-y-auto py-4 space-y-6">
        {sections.map(({ section, items }) => (
          <div key={section}>
            <div className="px-4 pb-2 text-xs font-medium uppercase tracking-wider text-gray-400 dark:text-gray-500">
              {section}
            </div>
            <ul className="space-y-0.5 px-2">
              {items.map((item) => (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    end={item.path === "/"}
                    title={item.description}
                    className={({ isActive }) =>
                      clsx(
                        "flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors",
                        isActive
                          ? "bg-purple-50 text-purple-700 dark:bg-purple-900/20 dark:text-purple-300"
                          : "text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800",
                        !item.ported &&
                          "opacity-60 hover:opacity-80",
                      )
                    }
                  >
                    <item.Icon className="w-4 h-4 flex-shrink-0" />
                    <span className="truncate">{item.label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  );
}
